import { useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { ParallaxScrollView } from '../src/components/animations';
import { LandingHeader } from '../src/components/landing/LandingHeader';
import { GridBackdrop } from '../src/components/landing/landingStyleKit';
import { PremiumFooter } from '../src/components/landing/PremiumFooter';
import { PricingSection } from '../src/components/landing/PricingSection';
import { useAccessGate } from '../src/hooks/useAccessGate';
import { trackEvent } from '../src/lib/analytics';
import { useMixpanel } from '../src/lib/mixpanel';
import { colors } from '../src/theme/colors';

export default function PricingPage() {
  const { destination } = useAccessGate();
  const mp = useMixpanel();

  useEffect(() => {
    trackEvent(mp, 'landing.section_viewed', { section: 'pricing' });
  }, [mp]);

  return (
    <View style={styles.wrapper}>
      <GridBackdrop />
      {Platform.OS === 'web' && <LandingHeader destination={destination} />}
      <ParallaxScrollView style={styles.container} contentContainerStyle={styles.content}>
        <View nativeID="pricing">
          <PricingSection destination={destination} />
        </View>
        <PremiumFooter />
      </ParallaxScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
  container: {
    flex: 1,
    backgroundColor: colors.transparent,
  },
  content: {
    flexGrow: 1,
  },
});
